import gql from 'graphql-tag';

export const GET_ALL_RIDERS = gql`
query GetAllRiders {
  GetAllRiders {
    id
    name
    email
    primaryContact
    secondaryContact
    address {
      zipcode
      line1
      line2
      state
      city
      country
    }
    isEnabled
    modifiedAt
    createdAt
  }
}`;

export const GET_RIDER_HISTORY = gql`
query GetHistoryByRiderId($assignedRiderId: String!, $startDate: String!, $endDate: String!, $page: Int!, $pageSize: Int!) {
    GetHistoryByRiderId(assignedRiderId: $assignedRiderId, startDate: $startDate, endDate: $endDate, page: $page, pageSize: $pageSize) {
      assignedRiderId
     deliveryCharge {
      baseFee
      tax
      total
    }
      destination {
        location
        name
      }
      id
      jobDate
      orderId
      origin {
        location
        name
      }
      searchParams {
        city
        range
      }
      tipAmount
    }
  }
`;

export const GET_EARNINGS_FOR_RIDER = gql`
query GetEarningsForRider($assignedRiderId: String, $startDate: String, $endDate: String) {
  GetEarningsForRider(assignedRiderId: $assignedRiderId, startDate: $startDate, endDate: $endDate)
}
`

export const GET_RIDER_BY_ID = gql`
query GetRiderById($getRiderByIdId: String) {
  GetRiderById(id: $getRiderByIdId) {
    id
    name
    email
    primaryContact
    secondaryContact
    address {
      zipcode
      line1
      line2
      state
      city
      country
    }
    isEnabled
    modifiedAt
    createdAt
  }
}`

export const CREATE_RIDER = gql`
  mutation CreateRider($rider: RiderInput) {
    CreateRider(rider: $rider) {
      id
      name
      email
      primaryContact
      secondaryContact
      address {
        zipcode
        line1
        line2
        state
        city
        country
      }
      isEnabled
      modifiedAt
      createdAt
    }
  }
`;